// Traslados entre bodegas: operación atómica vía Edge Function `trasladar`
// (valida stock en origen, descuenta origen y suma destino en una transacción).
import { insforge } from '../insforge';
import type { ItemTipo } from '../../types';

export interface EntradaTraslado {
  origenId: string;
  destinoId: string;
  tipo: ItemTipo;
  refId: string;
  cantidad: number;
  observaciones?: string;
}

export async function trasladar(input: EntradaTraslado): Promise<void> {
  const { error } = await insforge.functions.invoke('trasladar', {
    body: {
      origenId: input.origenId,
      destinoId: input.destinoId,
      tipo: input.tipo,
      refId: input.refId,
      cantidad: input.cantidad,
      observaciones: input.observaciones ?? '',
    },
  });
  if (error) throw new Error(error.message);
}
